'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useGetLastViewedPathQuery } from '@frameio/graphql-client/graphql/features/integrations';
import { useHasMounted } from '@frameio/vapor';
import { useSetLastViewedPathMutation } from './gql/mutations/generated/SetLastViewedPath';

const ignorePaths = [
  '/logout',
  '/authenticating',
  '/auth/callback',
  '/auth/login',
  '/unauthenticated',
  '/auth/refresh',
  '/preview',
];

export function UpdateLastViewedPath() {
  const pathname = usePathname();
  const hasMounted = useHasMounted();

  const { data } = useGetLastViewedPathQuery({
    context: {
      resolveWithUXP: true,
    },
  });

  const [setLastViewedPath] = useSetLastViewedPathMutation({
    context: {
      resolveWithUXP: true,
    },
    refetchQueries: ['GetLastViewedPath'],
  });

  const lastViewedPath = data?.getLastViewedPath?.path;

  useEffect(() => {
    if (!lastViewedPath) {
      return;
    }

    const shouldIgnorePath =
      ignorePaths.includes(pathname) ||
      pathname.includes('/view/') ||
      pathname === '/';

    if (hasMounted && pathname !== lastViewedPath && !shouldIgnorePath) {
      setLastViewedPath({
        variables: {
          input: {
            path: pathname,
          },
        },
      });
    }
  }, [hasMounted, lastViewedPath, pathname, setLastViewedPath]);

  return null;
}
